import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./Page.module.css";

const AnalysisPage = ({ intl }) => {
  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "analysis.title",
            defaultMessage: "Análise"
          })}{" "}
          - Vertex4D
        </title>
      </Helmet>
      <main>
        <header className={styles.pageHeader}>
          <div className={styles.container}>
            <div className={styles.breadcrumb}>
              <Link to="/">
                <FormattedMessage
                  id="breadcrumb.home"
                  defaultMessage="Início"
                />
              </Link>{" "}
              &gt;{" "}
              <span>
                <FormattedMessage
                  id="analysis.title"
                  defaultMessage="Análise"
                />
              </span>
            </div>
            <h1>
              <FormattedMessage
                id="analysis.title"
                defaultMessage="Análise"
              />
            </h1>
          </div>
        </header>
      </main>
    </>
  );
};

export default injectIntl(AnalysisPage);
